// extracted by mini-css-extract-plugin
export default {"title":"modal-title_title__3lQna"};